import { useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "utils/Table/Table";
import BankingWalletFilters from "../common/BankingWalletFilters";
import {
	virtualAccountTableData,
	virtualAccountTableHeadings,
	bankingWalletsFiltersDefaultValues,
} from "../helpers/data";

const BankingVirtualAccounts = () => {
	const history = useHistory();
	const [formValues, setFormValues] = useState({
		...bankingWalletsFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () =>
		setFormValues({ ...bankingWalletsFiltersDefaultValues });

	const getWalletData = () =>
		virtualAccountTableData?.map((transaction) => ({
			walletId: transaction?.walletId,
			customerId: transaction?.customerId,
			walletType: transaction?.walletType,
			name: transaction?.name,
			bank: transaction?.bank,
			number: transaction?.number,
			createdAt: transaction?.createdAt,
		}));

	const handleRowClick = (_, rowValues) => {
		history.push(
			`/banking/virtual-accounts/${rowValues.walletId.toLowerCase()}/account-details`
		);
	};
	return (
		<>
			<BankingWalletFilters
				formValues={formValues}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				handleSelect={handleSelect}
			/>
			<Table
				data={getWalletData()}
				headings={virtualAccountTableHeadings}
				rowClick={handleRowClick}
			/>
		</>
	);
};

export default BankingVirtualAccounts;
